import { FC } from 'react';

import { Box, SxProps, Tooltip } from '@mui/material';

import { useSession } from '~components/hooks/useSession';
import { black, secondaryColors } from '~components/theme/styles/colors';
import { NetworkIds } from '~config/rpcConfig';

import { VestaIcon, VestaNetworkIcons } from '../../icons/vesta';

export const AccountDialCurrentNetwork: FC<{ sx?: SxProps }> = ({ sx }) => {
  const { network } = useSession();

  function getNetworkHoverTitle() {
    if (!network.isChainValid) return 'Please switch to a valid network!';
    switch (network.networkId) {
      case NetworkIds.ARBITRUM_ONE:
        return 'Connected to the Arbitrum One Network';
      case NetworkIds.ARBITRUM_RINKEBY:
        return 'Connected to the Arbitrum One Goerli Network';
      default:
        return '???';
    }
  }

  return (
    <Tooltip placement={'bottom-start'} title={getNetworkHoverTitle()}>
      <Box component="span" sx={{ userSelect: 'none' }}>
        <VestaIcon
          outerContainerSx={{
            transition: 'border 0.25s ease',
            border: `1px solid ${black['100%']}`,
            '& :hover': { border: `1px solid ${secondaryColors[600]}` },
            ...sx,
          }}
          icon={VestaNetworkIcons.ARBITRUM}
        />
      </Box>
    </Tooltip>
  );
};
